<template>
    <div>
        <h4>Oferta wysłana do</h4>

        <div class="mt-3">
            <data-table
                  :headers="sentOffersHeaders"
                  :items="sentOffers"
                  class="elevation-1"
                  :loading="loading">

                <template v-slot:item.company.name="{ item }">
                    {{ item.company ? item.company.name : item.name }}
                </template>

                <template v-slot:item.www="{ item }">
                    <span v-html="wwwLink(item.www)"></span>
                </template>

                <template v-slot:item.email="{ item }">
                    <span v-html="emailLink(item.email)"></span>
                </template>

                <template v-slot:item.price="{ item }">
                    <span v-if="item.priceForOrder">
                      {{item.price ? item.price + 'zł' : '-' }}
                    </span>
                    <span v-else>
                      {{item.price ? item.price + 'zł/' + getUnitLabel(item.order.unit) : '-' }}
                    </span>

                </template>

                <template v-slot:item.status="{ item }">
                    {{ getStatusText(item.status) }}
                </template>

                <template v-slot:item.type="{ item }">
                    {{ getTypeText(item.type) }}
                </template>

                <template v-slot:item.paymentType="{ item }">
                    {{ getPaymentTypeText(item.paymentType) }}
                </template>

                <template v-if="actionsAvailable" v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            style="color: green;"
                            @click="servedByCallCenter(item)"
                            title='Oznacz jako "Obsłużona"'
                    >
                        mdi-checkbox-blank-circle
                    </v-icon>
                    <v-icon
                            small
                            @click="notServedByCallCenter(item)"
                            style="color: red;"
                            title='Oznacz jako "Nieobsłużona"'
                    >
                        mdi-checkbox-blank-circle
                    </v-icon>
                </template>

            </data-table>
        </div>
    </div>
</template>

<script>
    import api from '../../services/api';
    import {SentSaleOfferStatus, getStatusText} from '@/enums/SentSaleOfferStatus';
    import formatters from "@/mixins/formatters";
    import DataTable from "@/components/data-table/DataTable";
    import unitMixin from "@/mixins/unitMixin";

    export default {
        mixins: [formatters, unitMixin],
        props: ['saleOfferId', 'orderId', 'actionsAvailable'],
        components: {
          DataTable,
        },
        data() {
            let sentOfferHeaders = [
                { text: 'Firma', value: 'company.name' },
                { text: 'WWW', value: 'www' },
                { text: 'E-mail', value: 'email' },
                { text: 'Telefon', value: 'phone' },
                { text: 'Data', value: 'createdAt' },
                { text: 'Status', value: 'status' },
            ];


            if (this.orderId) {
              sentOfferHeaders.push({ text: 'Propozycja ceny', value: 'price', sortable: false });
              sentOfferHeaders.push({ text: 'Typ', value: 'type', sortable: false });
              sentOfferHeaders.push({ text: 'Forma płatności', value: 'paymentType', sortable: false });
              sentOfferHeaders.push({ text: 'Notatki', value: 'notes', sortable: false });
            }

            if (this.actionsAvailable) {
                sentOfferHeaders.push({ text: 'Akcje', value: 'actions', sortable: false });
            }

            return {
                loading: false,
                sentOffers: [],
                sentOffersHeaders: sentOfferHeaders
            }
        },
        methods: {
            async load() {
                this.loading = true;
                let response;

                if (this.saleOfferId) {
                  response = await api.get(`/api/sale-offers/sent`, {
                    params: {
                      saleOfferId: this.saleOfferId
                    }
                  });
                }

                if (this.orderId) {
                  response = await api.get(`/api/orders/sent`, {
                    params: {
                      orderId: this.orderId
                    }
                  });
                }

                this.sentOffers = response.data.items;

                this.loading = false;
            },
            async servedByCallCenter(item) {
                if (item.status === SentSaleOfferStatus.S.description) {
                    return;
                }
                await this.changeStatus(item.id, SentSaleOfferStatus.S.description);
                await this.load();
            },
            async notServedByCallCenter(item) {
                if (item.status === SentSaleOfferStatus.NS.description) {
                    return;
                }
                await this.changeStatus(item.id, SentSaleOfferStatus.NS.description);
                await this.load();
            },
            async changeStatus(id, status) {
                this.loading = true;
                if (!this.actionsAvailable) {
                    return;
                }
                await api.put(`/api/${this.orderId ? 'orders' : 'sale-offers'}/${id}/sent-status`, { status });
            },
            getStatusText(status) {
                return getStatusText(status);
            },
            getTypeText(type) {
              const typeMap = {
                paidUtilization: 'Płatna utylizacja',
                wastePurchase: 'Kupno odpadu',
                wasteFree: 'Bezpłatny odbiór',
              };

              return typeMap[type];
            },
            getPaymentTypeText(type) {
              const typeMap = {
                '': '',
                cash: 'Gotówka',
                transfer: 'Przelew',
              };

              return typeMap[type];
            }
        },
        created() {
            this.load();
        }
    }
</script>

<style scoped>

</style>